import $ from 'jquery';

export default function setupStyliticsToggle($selector) {
    if (!$selector) {
        return;
    }
    $selector.on('click', function(e) {
        var url = $(this).data("styliticsShop");
        $.ajax({
            type: 'POST',
            url: url,
            success: function (data) {
                $("#shop-this-look").html(data);
                $("#shop-this-look").removeClass("u-hide");
                $("#global-nav-div").addClass("u-hide");
                $(".js-pdp_main").addClass("u-hide");
                window.scrollTo(0, 0);
                var jsElement = $("#shop-this-look").find('.js-horizontal-scroll');
                if (jsElement.length) {
                    jsElement.horizontalScroll();
                }
            }
        });
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/stylitics-toggle.js